var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},_vm._l((_vm.list),function(item,index){return _c('TreeItem',{key:index,attrs:{"data":item,"checked":_vm.selectedMenuList.some(function (x) { return x.id === item.id; }),"selectedMenuList":_vm.selectedMenuList},on:{"itemChange":_vm.itemChange}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40f5e9fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/index.vue
// module id = null
// module chunks = 